import { Image } from './styles'

const Element = ({ url }) => {
  return <Image style={{ backgroundImage: `url(${url})` }} />
}

export default Element
